import React from "react"
import { Link } from "gatsby"
import { Nav, Dropdown } from "react-bootstrap"
import "./menu.css"

const MenuSide = () => (
  <div className="navigation">
    <Nav className="flex-column">
      <Nav.Item>
        <Link title="home" to="/">
          Home
        </Link>
      </Nav.Item>
      <Nav.Item>
        <Dropdown className="text-left">
          <Dropdown.Toggle variant="success" id="dropdown-basic">
            Who We Are
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item href="/alzhiemers-care">Who We Are</Dropdown.Item>
            <Dropdown.Item href="/memory-care-assisted-living-services">
              Memory Care Assisted Living Services
            </Dropdown.Item>
            <Dropdown.Item href="/geriatric-home-health-care">
              Geriatric Home Health Care
            </Dropdown.Item>
            <Dropdown.Item href="/dementia-assisted-living">
              Dementia Assisted Living
            </Dropdown.Item>
            <Dropdown.Item href="/continuing-care-center">
              Continuing Care Center
            </Dropdown.Item>
            <Dropdown.Item href="/hospice-services">
              Hospice Services
            </Dropdown.Item>
            <Dropdown.Item href="/our-history">Our History</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Nav.Item>
      <Nav.Item>
        <Dropdown className="text-left">
          <Dropdown.Toggle variant="success" id="dropdown-basic">
            What We Do
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item href="/alzheimers-home-memory-care-castle-rock">
              What We Do
            </Dropdown.Item>
            <Dropdown.Item href="/24-hour-home-care">
              24 Hour Home Care
            </Dropdown.Item>
            <Dropdown.Item href="/caregiver-support">
              Caregiver Support
            </Dropdown.Item>
            <Dropdown.Item href="/senior-living-options">
              Senior Living Options
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Nav.Item>
      <Nav.Item>
        <Link title="Activities" to="/alzheimers-activities">
          Activities
        </Link>
      </Nav.Item>
      <Nav.Item>
        <Link title="Sample Menu" to="/menu">
          Sample Menu
        </Link>
      </Nav.Item>
      <Nav.Item>
        <Dropdown className="text-left">
          <Dropdown.Toggle variant="success" id="dropdown-basic">
            Location
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item href="/location">All Locations</Dropdown.Item>
            <Dropdown.Item href="/assured-assisted-living-paonia-court-location">
              Paonia Court Location
            </Dropdown.Item>
            <Dropdown.Item href="/memory-care-facility-castle-rock-tarpan-place">
              Tarpan Place Location 1
            </Dropdown.Item>
            <Dropdown.Item href="/alzheimers-care-center-castle-rock-co-tarpan-place">
              Tarpan Place Location 2
            </Dropdown.Item>
            <Dropdown.Item href="/residential-assisted-living-facilities-castle-rock-sapling-court">
              Sapling Court Location
            </Dropdown.Item>
            <Dropdown.Item href="/dementia-care-facilities-castle-rock-thatch-circle-2">
              Thatch Circle Location
            </Dropdown.Item>
            <Dropdown.Item href="/alzheimers-care-parker-and-castle-rock/">
              Wagontrail Court Location
            </Dropdown.Item>
            <Dropdown.Item href="/assisted-living-parker-co">
              Riverstone Drive Location
            </Dropdown.Item>
            <Dropdown.Item href="/assured-assisted-living-meadowbrook-place-location">
              Meadowbrook Place Location
            </Dropdown.Item>
            <Dropdown.Item href="/alzheimers-care-centennial">
              Andes Court Location
            </Dropdown.Item>
            <Dropdown.Item href="/alzheimers-care-centennial">
              Sevens in Lakewood, CO
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Nav.Item>
      <Nav.Item className="mb-4">
        <Link title="Visitor Screening Form" to="/screening-form">
          Visitor Screening Form
        </Link>
      </Nav.Item>
      <Nav.Item className="mb-4">
        <Link title="blog" to="/blog">
          Blog
        </Link>
      </Nav.Item>
    </Nav>
    <p className="section-p text-left">
      Copyright © 2010-2019 Assured Assisted Living Castle Rock.
    </p>
  </div>
)
export default MenuSide
